import { Badge } from "@/components/ui/badge";

const STATUS_COLORS: Record<string, string> = {
  Draft: "bg-secondary text-muted-foreground hover:bg-secondary",
  Pending: "bg-warn-soft text-warn-ink hover:bg-warn-soft",
  Paid: "bg-info-soft text-info-ink hover:bg-info-soft",
  Processing: "bg-brand-soft text-brand-ink hover:bg-brand-soft",
  Complete: "bg-ok-soft text-ok-ink hover:bg-ok-soft",
  Failed: "bg-destructive-soft text-destructive-ink hover:bg-destructive-soft",
  Cancelled: "bg-secondary text-muted-foreground hover:bg-secondary",
  Refunded: "bg-warn-soft text-warn-ink hover:bg-warn-soft",
};

interface OrderStatusBadgeProps {
  status: string;
  /** A completed upgrade the infrastructure did not fully apply: reads as that, not as done. */
  notApplied?: boolean;
  className?: string;
}

/** Shared order-status badge — same color mapping used by the admin orders list table. */
export function OrderStatusBadge({
  status,
  notApplied = false,
  className,
}: OrderStatusBadgeProps) {
  const incomplete = status === "Complete" && notApplied;
  const colors = incomplete
    ? "bg-warn-soft text-warn-ink hover:bg-warn-soft"
    : STATUS_COLORS[status] || "bg-secondary text-muted-foreground";

  return (
    <Badge
      variant="outline"
      className={[
        "text-[11px] font-normal px-2 py-0.5 rounded-full border-transparent shadow-none",
        colors,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {incomplete ? "Not fully applied" : status}
    </Badge>
  );
}
